import { render, staticRenderFns } from "./blockChain.vue?vue&type=template&id=9c2c2bc2&scoped=true&"
var script = {}
import style0 from "./blockChain.vue?vue&type=style&index=0&id=9c2c2bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2c2bc2",
  null
  
)

export default component.exports